import { __assign, __awaiter, __generator, __spreadArray } from "tslib";
/* eslint-disable prettier/prettier */
/* eslint-disable no-extra-boolean-cast */
import React, { useEffect, useState } from "react";
import Xarrow, { Xwrapper, useXarrow } from "react-xarrows";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./styles.css";
import { DisplayTypeToIconMap } from "../graphical/ResourceTypesIcons";
import expandIcon from "./assets/icons/Expand.svg";
import { faMagnifyingGlassMinus, faMagnifyingGlassPlus, faSquareDashed } from "@fortawesome/pro-regular-svg-icons";
import collapseIcon from "./assets/icons/Collapse.svg";
import { styled } from "@mui/material";
var ControlButton = styled("button")({
    width: '40px',
    height: '40px',
    backgroundColor: 'white',
    border: "1px solid rgb(216, 221, 228)",
    borderRadius: '4px',
    color: 'rgb(84, 91, 113)',
    '&:active': {
        color: 'rgb(50, 103, 214)'
    },
    '&:hover': {
        backgroundColor: 'rgb(249, 251, 252)'
    }
});
export var Diagram = function (_a) {
    var width = _a.width, height = _a.height, data = _a.data, arrows = _a.arrows, maxColumnsLength = _a.maxColumnsLength, containerStyle = _a.containerStyle, columnStyle = _a.columnStyle;
    var _b = useState(null), selectedPath = _b[0], setSelectedPath = _b[1];
    var _c = useState([]), mappedPaths = _c[0], setMappedPaths = _c[1];
    var _d = useState(), visible = _d[0], setVisible = _d[1];
    var _e = useState({}), collapsibleItemsIndex = _e[0], setCollapsibleItemsIndex = _e[1];
    var _f = useState({}), collapsibleState = _f[0], setCollapsibleState = _f[1];
    var _g = useState(), arrowsModel = _g[0], setArrowsModel = _g[1];
    var _h = useState([]), dataModel = _h[0], setDataModel = _h[1];
    var _j = useState(100), zoom = _j[0], setZoom = _j[1];
    var updateXarrow = useXarrow();
    useEffect(function () {
        var paths = data[0];
        var _statePaths = [];
        paths.forEach(function (element) {
            if (element.route !== undefined && element.route !== null)
                _statePaths.push(__spreadArray([element.id], element.route, true));
        });
        setMappedPaths(_statePaths);
    }, [data]);
    var handlePath = function (node, indexX, indexY) {
        if (Boolean(data[indexX][indexY].route)) {
            var _path = findArrayWithElement(mappedPaths, node);
            setSelectedPath(_path);
        }
        else {
            connectPaths({
                startID: node,
                endID: node
            });
        }
    };
    function findArrayWithElement(arrays, element) {
        var _data = arrays.filter(function (array) { return array.includes(element); });
        return _data[0];
    }
    var connectPaths = function (node) { return __awaiter(void 0, void 0, void 0, function () {
        var isObject, prevNodes, nextNodes, current;
        return __generator(this, function (_a) {
            isObject = typeof node === "object";
            prevNodes = findPath(node.endID, false);
            nextNodes = findPath(node.startID, true);
            current = [node.endID, node.startID];
            // setSelectedPath([...current, ...nextNodes, ...prevNodes]);
            // setSelectedPath([...current]);
            if (isObject) {
                setSelectedPath(__spreadArray([], current, true));
            }
            else {
                setSelectedPath(__spreadArray(__spreadArray(__spreadArray([], current, true), nextNodes, true), prevNodes, true));
            }
            return [2 /*return*/];
        });
    }); };
    var findPath = function (node, prev) {
        if (arrows === undefined)
            return [];
        var found = [];
        var elementsFound = arrows.filter(function (element) {
            return prev ? element.endID === node : element.startID === node;
        });
        if (elementsFound.length) {
            elementsFound.forEach(function (foundElement) {
                prev
                    ? found.push.apply(found, __spreadArray([foundElement.startID], findPath(foundElement.startID, true), false)) : found.push.apply(found, __spreadArray([foundElement.endID], findPath(foundElement.endID, false), false));
            });
        }
        return found;
    };
    var toogleVisible = function (id) {
        if (visible === "" || visible !== id) {
            setVisible(id);
        }
        else if (visible === id) {
            setVisible("");
        }
    };
    var handleClick = function (e, action) {
        action.onClick(e);
        setVisible("");
    };
    var initArrows = function (collapsibleStateProps, collapsibleItemsIndexProps) {
        var index = [];
        for (var key in collapsibleStateProps) {
            if (collapsibleStateProps[key]) {
                index = index.concat(collapsibleItemsIndexProps[key]);
            }
        }
        var newArrows = [];
        arrows === null || arrows === void 0 ? void 0 : arrows.map((function (arrow) {
            if (!index.find((function (e) { return e === arrow.endID; }))) {
                newArrows === null || newArrows === void 0 ? void 0 : newArrows.push(arrow);
            }
        }));
        setArrowsModel(newArrows);
    };
    var updateArrows = function (collapsibleStateProps) {
        var index = [];
        for (var key in collapsibleStateProps) {
            if (collapsibleStateProps[key]) {
                index = index.concat(collapsibleItemsIndex[key]);
            }
        }
        var newArrows = [];
        arrows === null || arrows === void 0 ? void 0 : arrows.map((function (arrow) {
            if (!index.find((function (e) { return e === arrow.endID; }))) {
                newArrows === null || newArrows === void 0 ? void 0 : newArrows.push(arrow);
            }
        }));
        setArrowsModel(newArrows);
    };
    useEffect(function () {
        var stateCollapsible = {};
        var indexCollapsible = {};
        var invisibleNodes = [];
        data.map(function (column) {
            column.map(function (item) {
                var _a, _b;
                var id = item.id;
                if (item.collapsible) {
                    stateCollapsible = __assign(__assign({}, stateCollapsible), (_a = {}, _a[id] = true, _a));
                    if (arrows !== undefined) {
                        var indexArray = [];
                        var _loop_1 = function (i) {
                            if (arrows[i].startID == id || indexArray.find(function (e) { return (e === arrows[i].startID); })) {
                                indexArray.push(arrows[i].endID);
                                invisibleNodes.push(arrows[i].endID);
                            }
                        };
                        for (var i = 0; i < (arrows === null || arrows === void 0 ? void 0 : arrows.length); i++) {
                            _loop_1(i);
                        }
                        indexCollapsible = __assign(__assign({}, indexCollapsible), (_b = {}, _b[id] = indexArray, _b));
                    }
                }
            });
        });
        var dataInit = data;
        dataInit === null || dataInit === void 0 ? void 0 : dataInit.map(function (column) {
            column.map(function (item) {
                if (invisibleNodes.find(function (e) { return e === item.id; })) {
                    item['visible'] = false;
                }
            });
        });
        // setDataModel(dataInit)
        displayColumns(dataInit);
        setCollapsibleItemsIndex(indexCollapsible);
        setCollapsibleState(stateCollapsible);
        initArrows(stateCollapsible, indexCollapsible);
    }, [data]);
    // useEffect(() => {
    //   setDataModel(data)
    //   setArrowsModel(arrows)
    // }, [])
    var onClickCollapsibleItem = function (element) {
        var _a, _b;
        if (!collapsibleState[element.id]) {
            var dataCollapsed = dataModel;
            dataCollapsed === null || dataCollapsed === void 0 ? void 0 : dataCollapsed.map(function (column) {
                column.map(function (item) {
                    if (collapsibleItemsIndex[element.id].find(function (e) { return e === item.id; })) {
                        item['visible'] = false;
                    }
                });
            });
            // setDataModel(dataCollapsed)
            displayColumns(dataCollapsed);
        }
        else {
            var dataCollapsed = dataModel;
            dataCollapsed === null || dataCollapsed === void 0 ? void 0 : dataCollapsed.map(function (column) {
                column.map(function (item) {
                    if (collapsibleItemsIndex[element.id].find(function (e) { return e === item.id; })) {
                        item['visible'] = true;
                    }
                });
            });
            // setDataModel(dataCollapsed)
            displayColumns(dataCollapsed);
        }
        setCollapsibleState(__assign(__assign({}, collapsibleState), (_a = {}, _a[element.id] = !collapsibleState[element.id], _a)));
        updateArrows(__assign(__assign({}, collapsibleState), (_b = {}, _b[element.id] = !collapsibleState[element.id], _b)));
        setZoom(50);
    };
    var displayColumns = function (columns) {
        var maxColumns = [];
        if (maxColumnsLength) {
            columns.map(function (column, index) {
                var maxCount = 0;
                var arrayColumn = [];
                column.map(function (element) {
                    if (maxCount < maxColumnsLength) {
                        arrayColumn.push(element);
                        maxCount = maxCount + 1;
                    }
                    else {
                        maxColumns.push(arrayColumn);
                        maxCount = 0;
                        arrayColumn = [element];
                    }
                });
                if (arrayColumn.length > 0) {
                    maxColumns.push(arrayColumn);
                }
            });
        }
        else {
            maxColumns = columns;
        }
        setDataModel(maxColumns);
    };
    return (React.createElement("div", { style: {
            position: 'relative',
            width: width || '100%',
            height: height
        } },
        React.createElement("div", { style: {
                padding: 15,
                position: 'absolute',
                right: 0,
                zIndex: 51
            } },
            React.createElement(ControlButton, { onClick: function () {
                    setZoom(60);
                } },
                React.createElement(FontAwesomeIcon, { icon: faSquareDashed })),
            React.createElement(ControlButton, { className: "control-button", style: { marginLeft: 10 }, onClick: function () {
                    if (zoom < 190) {
                        setZoom(zoom + 10);
                    }
                } },
                React.createElement(FontAwesomeIcon, { icon: faMagnifyingGlassPlus })),
            React.createElement(ControlButton, { className: "control-button", style: { marginLeft: 10 }, onClick: function () {
                    if (zoom > 50) {
                        setZoom(zoom - 10);
                    }
                } },
                React.createElement(FontAwesomeIcon, { icon: faMagnifyingGlassMinus }))),
        React.createElement("div", { onClick: function () {
                if (visible !== "") {
                    setVisible("");
                }
            }, className: "container", style: __assign({}, containerStyle), onScroll: updateXarrow },
            React.createElement("div", { className: "dia-content", style: { zoom: zoom + '%' } },
                React.createElement(Xwrapper, null, dataModel === null || dataModel === void 0 ? void 0 : dataModel.map(function (column, index) {
                    var displayContent = false;
                    for (var i in column) {
                        if (column[i].visible === true || column[i].visible === undefined) {
                            displayContent = true;
                            break;
                        }
                    }
                    return displayContent && (
                    // <div key={index} className="dia-column" style={{ paddingInline:(((150 - zoom) / 2) + 1) > 1 ? (((150 - zoom) / 2) + 1) : 1 + 'px' }}>
                    React.createElement("div", { key: index, className: "dia-column", style: {} },
                        column.map(function (element, i) {
                            if (element.visible !== false) {
                                return (React.createElement("div", { key: "".concat(index, "-").concat(i), className: "element-container ".concat(index !== data.length - 1 ? "element-col" : "") },
                                    React.createElement("div", { className: "diadropdown" },
                                        React.createElement("div", { id: element.id, className: "dia-row ".concat(!((element.type !== undefined &&
                                                element.type !== null) ||
                                                !!element.icon)
                                                ? "dia-row_placehold"
                                                : ""), style: __assign({}, columnStyle), onMouseOver: function () { return handlePath(element.id, index, i); }, onMouseLeave: function () { return setSelectedPath(null); }, onClick: function () { return toogleVisible(element.id); } }, 
                                        //element.type !== undefined && element.type !== null && element.type < types.length ? (
                                        element.type !== undefined && element.type !== null ? (React.createElement("img", { 
                                            //src={`${types[element.type]}`}
                                            src: "".concat(DisplayTypeToIconMap[element.type]), 
                                            //alt={types[element.type]}
                                            alt: DisplayTypeToIconMap[element.type], height: "100%", width: "100%", style: { borderRadius: '4px' } })) : element.icon ? (React.createElement("img", { src: element.icon, alt: element.value, height: "100%", width: "100%", style: { borderRadius: '4px' } })) : (element.id)),
                                        (element.actions && element.actions.length >= 1) || element.collapsible ?
                                            React.createElement("div", { className: "diadropdown-content ".concat(visible === element.id ? "show-dropdown" : ""), style: { zIndex: 9999 } },
                                                !!element.actions &&
                                                    element.actions.map(function (action) {
                                                        if (action.type === element.type ||
                                                            action.type === undefined ||
                                                            action.type === null) {
                                                            return (React.createElement("div", { className: "actions-text", key: "option-".concat(action.id), id: "".concat(action.id), onClick: function (e) { return handleClick(e, action); } }, action.label));
                                                        }
                                                        else {
                                                            return null;
                                                        }
                                                    }),
                                                element.collapsible && (React.createElement("div", { className: "actions-text", key: "option-".concat(element.id), id: "collapsible-action-".concat(element.id), onClick: function (e) { return onClickCollapsibleItem({ id: element.id }); } }, "".concat(collapsibleState[element.id] ?
                                                    "Expand resources" : "Collapse resources"))))
                                            :
                                                null),
                                    element.collapsible &&
                                        React.createElement("div", { className: "button-collapsible-container" },
                                            React.createElement("button", { className: "button-collapsible", onClick: function () { onClickCollapsibleItem({ id: element.id }); } }, !collapsibleState[element.id] ?
                                                React.createElement("img", { src: collapseIcon, alt: "-", height: "100%", width: "100%" }) :
                                                React.createElement("img", { src: expandIcon, alt: "+", height: "100%", width: "100%" }))),
                                    React.createElement("div", { className: element.collapsible ? "text-container-collapsible" : "text-container" },
                                        React.createElement("p", { className: "element-label" }, element.label),
                                        element.description && (
                                        // <p className="element-description" style={{ fontSize: (((100 - zoom) / 4) + 14) > 14 ? (((100 - zoom) / 4) + 14) : 14 + 'px' }}>
                                        React.createElement("p", { className: "element-description" }, element.description)),
                                        collapsibleState[element.id] && (
                                        // <p className="element-description" style={{ fontSize: (((100 - zoom) / 4) + 14) > 14 ? (((100 - zoom) / 4) + 14) : 14 + 'px' }}>
                                        React.createElement("p", { className: "element-description" },
                                            collapsibleItemsIndex[element.id].length,
                                            " items collapsed")))));
                            }
                            else {
                                return null;
                            }
                        }),
                        arrowsModel &&
                            arrowsModel.map(function (arrow, i) {
                                var hovered = !!selectedPath &&
                                    selectedPath.find(function (id) { return arrow.startID === id; }) &&
                                    selectedPath.find(function (id) { return arrow.endID === id; });
                                return (React.createElement(Xarrow, { key: "arrow-".concat(i), divContainerStyle: { zIndex: 50 }, color: "".concat(hovered ? "#D8A032" : "#C8CDD4"), zIndex: hovered ? 999 : 10, showHead: arrow.showHead || false, showTail: arrow.showTail || false, strokeWidth: 2, passProps: {
                                        onMouseOver: function () {
                                            connectPaths(arrow);
                                        },
                                        onMouseLeave: function () {
                                            setSelectedPath(null);
                                        }
                                    }, end: String(arrow.endID), start: String(arrow.startID), endAnchor: "left", startAnchor: "right", dashness: arrow.dashness || false }));
                            })));
                }))))));
};
//export default Diagram;
